import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ArticlesMenuComponent } from './components/articles-menu/articles-menu.component';
import { LoginComponent } from './components/login/login.component';
import { MyAccountComponent } from './components/my-account/my-account.component';
import { OrderDetailComponent } from './components/order-detail/order-detail.component';
import { OrderSummaryComponent } from './components/order-summary/order-summary.component';
import { OrdersHistoryComponent } from './components/orders-history/orders-history.component';
import { AuthShopGuardService } from './services/auth/auth-shop-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'orders-details/:id',
    component: OrderDetailComponent, canActivate: [AuthShopGuardService]
  },
  {
    path: 'orders-summary',
    component: OrderSummaryComponent, canActivate: [AuthShopGuardService]
  },
  {
    path: 'articles',
    component: ArticlesMenuComponent, canActivate: [AuthShopGuardService]
  },
  {
    path: 'my-account',
    component: MyAccountComponent, canActivate: [AuthShopGuardService]
  },
  {
    path: 'history',
    component: OrdersHistoryComponent, canActivate: [AuthShopGuardService] 
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
